import { render } from "./generatedOrders.vue?vue&type=template&id=353fbf94&scoped=true"
import script from "./generatedOrders.vue?vue&type=script&lang=js"
export * from "./generatedOrders.vue?vue&type=script&lang=js"

import "./generatedOrders.vue?vue&type=style&index=0&id=353fbf94&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-353fbf94"

export default script